var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('navbar'),_c('FadeTransition',{attrs:{"duration":400,"mode":"out-in"}},[_c('router-view',{staticStyle:{"min-height":"100%"}})],1),_c('footerComp')],1)}
var staticRenderFns = []

export { render, staticRenderFns }